export type Weekday =
  | "monday"
  | "tuesday"
  | "wednesday"
  | "thursday"
  | "friday"
  | "saturday"
  | "sunday";

export const DAYS_OPTIONS: Record<Weekday, string> = {
  monday: "Monday",
  tuesday: "Tuesday",
  wednesday: "Wednesday",
  thursday: "Thursday",
  friday: "Friday",
  saturday: "Saturday",
  sunday: "Sunday",
};

/**
 * Gets translated day options using a translation function.
 * @param t - Translation function from useTranslations or getTranslations
 * @returns Record mapping weekday keys to translated day names
 */
export function getDaysOptions(
  t: (key: string) => string,
): Record<Weekday, string> {
  return {
    monday: t("days.monday"),
    tuesday: t("days.tuesday"),
    wednesday: t("days.wednesday"),
    thursday: t("days.thursday"),
    friday: t("days.friday"),
    saturday: t("days.saturday"),
    sunday: t("days.sunday"),
  };
}

export type DayAvailability = {
  day: Weekday;
  enabled: boolean;
  slots: TimeSlot[];
};

export type TimeSlot = {
  startTime: string; // Format: "HH:MM" (24-hour)
  endTime: string; // Format: "HH:MM" (24-hour)
};

export const defaultSlot: TimeSlot = { startTime: "09:00", endTime: "17:00" };

export const defaultAvailability: DayAvailability[] = [
  {
    day: "monday",
    enabled: true,
    slots: [defaultSlot],
  },
  {
    day: "tuesday",
    enabled: true,
    slots: [defaultSlot],
  },
  {
    day: "wednesday",
    enabled: true,
    slots: [defaultSlot],
  },
  {
    day: "thursday",
    enabled: true,
    slots: [defaultSlot],
  },
  {
    day: "friday",
    enabled: true,
    slots: [defaultSlot],
  },
  {
    day: "saturday",
    enabled: false,
    slots: [defaultSlot],
  },
  {
    day: "sunday",
    enabled: false,
    slots: [defaultSlot],
  },
];
